module.exports = __webpack_public_path__ + "static/media/First Light ZTG 4065_720.ffacf6c4.jpeg";